import { render, staticRenderFns } from "./Services_group_op.vue?vue&type=template&id=673eb7dc"
import script from "./Services_group_op.vue?vue&type=script&lang=js"
export * from "./Services_group_op.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports